<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const USERS = 'get_users.php'
	const ACT_INFO = 'get_act_info.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'conclusionUsers',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		methods: {
			change () {
				EventBus.$emit(`edit_conclusion_user`, this.selected)
			}
		},
		created: function () {
			fetch(DB + ACT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_6
			})
			.then(id => {
				fetch(DB + USERS, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = [{id: '0', name: ''}, ...data]; 
						this.selected = id
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))

			
		},
		beforeDestroy () {
			EventBus.$off('set_conclusion_user')
		}
	}
</script>


// WEBPACK FOOTER //
// conclusionUser.vue?46a8361a